import { useState } from "react";
import TableResultsComponent from "./TableResults";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { trackEvent, AI_SERACH } from "../utils/googleAnalytics";

const AI = ({ token }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [submittedSearchTerm, setSubmittedSearchTerm] = useState("");
  const [error, setError] = useState(null);
  const [key, setKey] = useState(0);
  const [isFiltersExpanded, setIsFiltersExpanded] = useState(true);
  const [isResultsExpanded, setIsResultsExpanded] = useState(false);

  const toggleFiltersSection = (e) => {
    e.stopPropagation();
    setIsFiltersExpanded(!isFiltersExpanded);
  };

  const toggleResultsSection = (e) => {
    e.stopPropagation();
    setIsResultsExpanded(!isResultsExpanded);
  };

  const handleSubmit = async (e) => {
    trackEvent(AI_SERACH, "AI Search");
    e.preventDefault();

    if (!searchTerm.trim()) {
      setError(
        "Search term cannot be empty. Please enter a valid search term.",
      );
      return;
    }
    if (searchTerm !== submittedSearchTerm) {
      setSubmittedSearchTerm(searchTerm);
      setKey((prevKey) => prevKey + 1);
      setIsFiltersExpanded(false);
      setIsResultsExpanded(true);
    }
  };

  return (
    <div className="search-container-1">
      {/* Filters Card */}
      <div className="content-card global-content-card">
        <button
          type="button"
          className="card-header"
          onClick={toggleFiltersSection}
          aria-expanded={isFiltersExpanded}
          aria-controls="filters-section"
          aria-label={isFiltersExpanded ? "Collapse filters" : "Expand filters"}
        >
          <span className="card-title">AI-Based Search</span>
          <span className="accordion-controls" aria-hidden="true">
            <span
              className={`toggle-btn ${
                isFiltersExpanded ? "expanded" : "collapsed"
              }`}
            >
              {isFiltersExpanded ? (
                <FaChevronUp className="up-rotate" />
              ) : (
                <FaChevronDown className="down-rotate" />
              )}
            </span>
          </span>
        </button>
        <div
          id="filters-section"
          className={`card-body ${
            isFiltersExpanded ? "expanded" : "collapsed"
          }`}
        >
          <div className="step">
            <div className="step-container">
              <p className="step-text">
                Enter a question or statement in the search box as you would
                naturally speak or write.
              </p>
            </div>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Type in your search and press Enter..."
                className="keyword-search-input"
              />
              {error && <div className="error-message">{error}</div>}
            </form>
          </div>
        </div>
      </div>

      {/* Results Card */}
      {submittedSearchTerm && (
        <div className="content-card">
          <button
            type="button"
            className="card-header"
            onClick={toggleResultsSection}
            aria-expanded={isResultsExpanded}
            aria-controls="results-section"
            aria-label={
              isResultsExpanded ? "Collapse results" : "Expand results"
            }
          >
            <span className="card-title">Results</span>
            <span className="accordion-controls" aria-hidden="true">
              <span
                className={`toggle-btn ${
                  isResultsExpanded ? "expanded" : "collapsed"
                }`}
              >
                {isResultsExpanded ? (
                  <FaChevronUp className="up-rotate" />
                ) : (
                  <FaChevronDown className="down-rotate" />
                )}
              </span>
            </span>
          </button>
          <div
            id="results-section"
            className={`card-body ${
              isResultsExpanded ? "expanded" : "collapsed"
            }`}
          >
            <TableResultsComponent
              key={key}
              submittedSearchTerm={JSON.stringify(submittedSearchTerm)}
              path="/nlp/search"
              ssp={true}
              token={token}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AI;
